import { FC } from 'react'

import { PrimaryAlert } from 'src/Components/PrimaryAlert'

interface PayoutAlertsProps {
  isSubmitSuccessAlert: boolean
  isSubmitFailedAlert: boolean
  setIsSubmitSuccessAlert: (state: boolean) => void
  setIsSubmitFailedAlert: (state: boolean) => void
  errorMessage: string
}

export const PayoutAlerts: FC<PayoutAlertsProps> = (props) => {
  const {
    errorMessage,
    isSubmitSuccessAlert,
    isSubmitFailedAlert,
    setIsSubmitFailedAlert,
    setIsSubmitSuccessAlert,
  } = props
  return (
    <>
      {isSubmitSuccessAlert && (
        <PrimaryAlert
          type='success'
          title='Great! Your bank details is set up.'
          onClose={() => setIsSubmitSuccessAlert(false)}
        >
          Now you can request payouts.
        </PrimaryAlert>
      )}
      {isSubmitFailedAlert && (
        <PrimaryAlert
          type='danger'
          title='Error'
          onClose={() => setIsSubmitFailedAlert(false)}
        >
          {errorMessage}
        </PrimaryAlert>
      )}
    </>
  )
}
